module.exports = __webpack_public_path__ + "static/media/card-background.1af2f007.png";